import { useMutation } from '@apollo/react-hooks';
import {
  updateAdSetDailySpendCapModeMutation,
  updateAdSetDailySpendCapModeMutation_updateAdSetDailySpendCapMode_adSet,
  updateAdSetDailySpendCapModeMutationVariables
} from './__generated__/updateAdSetDailySpendCapModeMutation';
import { kmsClient } from 'api';
import { UPDATE_AD_SET_DAILY_SPEND_CAP_MODE_MUTATION } from './updateAdSetDailySpendCapMode.mutation';

type MutationProps = {
  onStart?: () => void;
  onCompleted?: (adSetId: updateAdSetDailySpendCapModeMutation_updateAdSetDailySpendCapMode_adSet) => void;
  onError?: (errors: string[]) => void;
};

export const useUpdateAdSetDailySpendCapMode = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [updateAdSetDailySpendCapMode] = useMutation<
    updateAdSetDailySpendCapModeMutation,
    updateAdSetDailySpendCapModeMutationVariables
  >(UPDATE_AD_SET_DAILY_SPEND_CAP_MODE_MUTATION, {
    client: kmsClient,
    onCompleted: (data) => {
      if (data.updateAdSetDailySpendCapMode?.errors?.length) {
        if (onError) onError(data.updateAdSetDailySpendCapMode.errors);
      } else {
        if (onCompleted && data.updateAdSetDailySpendCapMode?.adSet)
          onCompleted(data.updateAdSetDailySpendCapMode.adSet);
      }
    },
    onError: (error) => onError && onError([error.message])
  });
  return (variables: updateAdSetDailySpendCapModeMutationVariables) => {
    if (onStart) onStart();
    updateAdSetDailySpendCapMode({ variables });
  };
};
